import { Component, ElementRef, inject, OnInit, ViewChild, AfterContentInit } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { EditSchainService } from '../../services';
import { SourceSchainInterface } from '../../models';
import { DropdownInterface } from '../../../../core/models';
import { AuthService } from '../../../../core/services';
import { sourceSchainRowLimitDescription } from '../../helpers/source-schain-partner-messages';

@Component({
  selector: 'app-edit-dsp-source',
  standalone: false,
  templateUrl: './edit-dsp-source.component.html',
  styleUrl: './edit-dsp-source.component.scss'
})
export class EditDspSourceComponent implements OnInit, AfterContentInit {

  public data = inject(NZ_MODAL_DATA) as {
    sourceData: SourceSchainInterface.ISourceSchain;
    checkedCompanies: number[];
    companies: DropdownInterface.ICompaniesDataGeneralSource[];
  };

  protected contentHeight = 'auto';

  @ViewChild('fileInput') protected fileInput: ElementRef;

  constructor(
    protected editSchainService: EditSchainService,
    private dialogRef: NzModalRef<EditDspSourceComponent>,
    private authService: AuthService,
  ) { }

  protected get rowLimitDescription(): string {
    return sourceSchainRowLimitDescription(this.authService.partner.id);
  }

  public ngOnInit(): void {
    this.editSchainService.initComponent(this.data);
  }

  public ngAfterContentInit(): void {
    this.contentHeight = window.innerHeight - 250 + 'px';
    window.addEventListener('resize', () => {
      this.contentHeight = window.innerHeight - 250 + 'px';
    });
  }

  protected onUploadFile(event: Event): void {
    this.editSchainService.onUploadFileHandler(event, () => this.fileInput.nativeElement.value = '', 'dsp');
  }

  protected onDownloadFile(): void {
    this.editSchainService.onDownloadFileHandler();
  }

  protected onDeleteFile(): void {
    this.editSchainService.onDeleteFileHandler();
  }

  protected onCancelUpload(): void {
    this.editSchainService.onCancelUploadHandler('dsp');
  }

  protected onCloseModal(): void {
    this.editSchainService.onCloseModalHandler((value: boolean) => this.dialogRef.close(value));
  }

  protected onUpdateDspSource(): void {
    this.editSchainService.onUpdateSourceSchainHandler(() => this.dialogRef.close(), 'dsp');
  }
}
